import { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { Transition } from "react-transition-group";
import { Animation } from "../Animation";
import { connect, useDispatch } from "react-redux";
import { hideModal } from "../../store/actions/modal";

import {
	ModalBackdrop,
	Modal,
	ModalDialog,
	ModalContent,
	ModalHeader,
	ModalBody,
	Title,
	Close,
	ModalAnimation,
} from "./styles";

export interface ModalProps {
	animation?: string;
	children: any;
	showClose?: boolean;
	title?: string;
	name: string;
	onClose?: () => void;
	visibleModal?: string | null;
	styles?: any;
	width?: string;
}

export const Component = ({
	animation = "fadeInSlideUp",
	showClose = true,
	children,
	title,
	name,
	onClose,
	visibleModal,
	styles,
	width,
}: ModalProps) => {
	const modalDOM = document.getElementById("modal") as HTMLElement;
	const dispatch = useDispatch();
	const [isVisible, setIsVisible] = useState(false);

	const handleClose = () => {
		dispatch(hideModal());
		setIsVisible(false);

		if (onClose) {
			onClose();
		}
	};

	const setBodyStyles = () => {
		if (isVisible) {
			document.body.style.height = "100%";
			document.body.style.overflow = "hidden";
		} else {
			document.body.style.height = "auto";
			document.body.style.overflow = "auto";
		}
	};

	useEffect(() => {
		setIsVisible(name === visibleModal);
	}, [name, visibleModal]);

	useEffect(() => {
		setBodyStyles();
	}, [isVisible]);

	if (!isVisible) {
		return null;
	}

	return ReactDOM.createPortal(
		<Transition in={isVisible} timeout={350} mountOnEnter>
			{(state) => (
				<>
					<ModalAnimation
						name={animation}
						className={`animation-${state}`}
						width={width}
						duration={0.4}
						{...(!!styles && styles)}
					>
						<Modal>
							<ModalDialog width={width}>
								<ModalContent>
									<ModalHeader>
										{showClose && (
											<Close 
												onClick={(e) => {
													e.preventDefault();
													e.stopPropagation();
													handleClose();
												}}
												onTouchEnd={(e) => {
													e.preventDefault();
													e.stopPropagation();
													handleClose();
												}}
											>
												<p
													style={{
														cursor: "pointer",
														fontSize: "2rem",
														margin: 0,
														userSelect: "none",
													}}
												>
													×
												</p>
											</Close>
										)}
										{!!title && <Title>{title}</Title>}
									</ModalHeader>
									<ModalBody>{children}</ModalBody>

									{/* <ModalFooter></ModalFooter> */}
								</ModalContent>
							</ModalDialog>
						</Modal>
					</ModalAnimation>

					<Animation name="fadeIn" className={`animation-${state}`}>
						<ModalBackdrop onClick={() => handleClose()} />
					</Animation>
				</>
			)}
		</Transition>,
		modalDOM
	);
};

const state = ({ modalStore }) => ({ ...modalStore });

export default connect(state)(Component);
